import { useState } from "react";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationDE from "../../locale/de/translation.json";
import translationEN from "../../locale/en/translation.json";
import {
  Text,
  createTableColumn,
  Tooltip,
  Link,
} from "@fluentui/react-components";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import useWindowSize from "../../helpers/useWindowSize";

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

// initialize i18next with catalog and language to use
i18n.use(LanguageDetector).init({
  resources,
});

interface IAngelHeadSelectionColumns {
  preiseSichtbar: boolean;
  selectedWinkelKopf: any;
}
function AngelHeadSelectionColumns(props: IAngelHeadSelectionColumns) {
  const [clickedArtikel, setClickedArtikel] = useState<ILSP3ResponseDto>();
  const windowSize = useWindowSize();

  const columns = [
    // ------------Artikel------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("artikelIdTooltip")}
            relationship="label"
          >
            <Text> {i18n.t<string>("artikelId")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        if (windowSize.width > 500) {
          if (item.hasSachwerte) {
            return (
              <Tooltip
                content={i18n.t<string>("displayTechnicalData")}
                relationship="label"
              >
                <Link
                  onClick={() => {
                    setClickedArtikel(item);
                  }}
                >
                  {item.artikelId}
                </Link>
              </Tooltip>
            );
          } else {
            return <Text>{item.artikelId}</Text>;
          }
        } else {
          <>
            <Text>{item.artikelId}</Text>
            <Text>
              {item.artikel ? item.artikel.benennungDE : item.benennungDE}
            </Text>
          </>;
        }
      },
    }),
    // ------------ BENNENUNG -------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de")
              ? item.artikel.benennungDE
              : item.artikel.benennungEN}
          </Text>
        );
      },
    }),
    // ------------AchsWinkel------------
    createTableColumn<any>({
      columnId: "achswinkelAbtriebId",
      renderHeaderCell: () => {
        return (
          <Tooltip relationship="label" content={i18n.t<string>("achswinkel")}>
            <Text>{i18n.t<string>("AW[°]")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return <Text>{item.achswinkel + "°"}</Text>;
      },
    }),
    // ------ Übersetzungsverhältnis ------
    createTableColumn<any>({
      columnId: "uebersetzungId",
      renderHeaderCell: () => {
        return <Text>{i18n.t<string>("uebersetzungsverhaeltnis")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.uebersetzungsverhaeltnis
              ? item.uebersetzungsverhaeltnis?.toLocaleString()
              : "-"}
          </Text>
        );
      },
    }),
  ];
  if (props.preiseSichtbar) {
    columns.push(
      // ------------preis------------
      createTableColumn<ILSP3ResponseDto>({
        columnId: "preis",
        renderHeaderCell: () => {
          return (
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("preisTooltip")}</div>}
            >
              <Text>
                {i18n.t<string>("preis")}
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
              </Text>
            </Tooltip>
          );
        },
        renderCell: (item) => {
          if (item.hasOwnProperty("artikel") && item.artikel) {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.artikel?.netto
                    ? item.artikel?.netto.toLocaleString(
                        i18n.language.includes("de") ? "de-DE" : "en-EN",
                        { minimumFractionDigits: 2 },
                      ) + " €"
                    : ""}
                </Text>
              </div>
            );
          } else {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.netto
                    ? item.netto.toFixed(2).toLocaleString() + " €"
                    : ""}
                </Text>
              </div>
            );
          }
        },
      }),
    );
  }
  return {
    columns: columns,
    clickedArtikel: clickedArtikel,
    resetClickedArtikel: () => {
      setClickedArtikel(undefined);
    },
  };
}
export default AngelHeadSelectionColumns;
